export const buildPaginationRequestParams = (page, pageSize) => {
  if (page !== undefined) {
    return {
      offset: (page - 1) * pageSize,
      size: pageSize,
    };
  }
  return {};
};

export const getLastPage = (entityCount, pageSize) => {
  return Math.ceil(entityCount / pageSize);
};



// WEBPACK FOOTER //
// ./app/services/pagination.js